module.exports = __webpack_public_path__ + "public/img/hubvet_icon.e7379f61.svg";